import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import { getFormValues, isInvalid } from 'redux-form';
import { initialState } from './reducer';
import { AUTOPARK_FORM_NAME } from './constants';

export const selectAutoparkModalDomain = state => state.autoparkModalReducer || initialState;

export const selectRouterDomain = state => state.router || {};

export const getIsAutoparkInfoLoadingSelector = () =>
	createSelector(
		selectAutoparkModalDomain,
		({ isAutoparkInfoLoading, isAutoparkCreating, isAutoparkUpdating, isAutoparkDeleting }) =>
			isAutoparkInfoLoading || isAutoparkCreating || isAutoparkUpdating || isAutoparkDeleting,
	);

export const getAutoparkInfoSelector = () =>
	createSelector(selectAutoparkModalDomain, ({ autoparkInfo }) => autoparkInfo);

export const getAutoparkNameSelector = () =>
	createSelector(selectAutoparkModalDomain, ({ autoparkInfo }) => {
		return autoparkInfo && autoparkInfo.tk
			? `${autoparkInfo.tk.name}${autoparkInfo.name ? `, ${autoparkInfo.name}` : ''}`
			: '';
	});

export const getIsModalShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'autopark');
	});

export const getIsAuditTabShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'autopark' && query?.id && query?.tab === 'audit');
	});

export const getIsAutoparkAddFormOpenSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'autopark' && query?.mode === 'add');
	});

export const getIsAutoparkEditFormOpenSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'autopark' && query?.mode === 'edit');
	});

export const getFormInitialValuesSelector = () =>
	createSelector(selectAutoparkModalDomain, ({ autoparkInfo }) => {
		return {
			...autoparkInfo,
			tk_id: autoparkInfo?.tk?.id,
		};
	});

export const getAutoparkCompaniesListSelector = () =>
	createSelector(selectAutoparkModalDomain, ({ autoparkCompaniesList }) => autoparkCompaniesList);

export const getIsAutoparkCompaniesListLoadingSelector = () =>
	createSelector(selectAutoparkModalDomain, ({ isAutoparkCompaniesListLoading }) => isAutoparkCompaniesListLoading);

export const getDataForSaveSelector = () =>
	createSelector(getFormValues(AUTOPARK_FORM_NAME), formValues => {
		return {
			tk_id: formValues?.tk_id,
			name: formValues?.name,
		};
	});

export const getFormIsInvalidSelector = () => createSelector(isInvalid(AUTOPARK_FORM_NAME), isInvalid => isInvalid);
